export const packageDataMock = {
	data: {
		usage: {
			currency_symbol: '£',
			credits_spent_in_30_days: 225,
			purchased_leads: 9,
			avg_monthly_spend_in_pence: 36864,
			price_per_credit_in_pence: 160,
			oldest_purchased_lead_date: '2023-09-03 00:29:59',
			oldest_spend_date: '2023-09-03 00:29:59',
			total_spend_in_pence: '12288',
			days_of_purchased_leads: 10,
			days_of_spend: 30,
			credits_per_purchased_lead: '8.3333',
		},
		packages: [
			{
				name: 'silver',
				credits_per_month: 384,
				credits_per_week: 38,
				purchased_leads_per_month: 468,
				purchased_leads_per_week: 48,
				price_per_month_in_pence: 45312,
				price_per_week_in_pence: 4312,
				price_per_credit_in_pence: 118,
				discount_percentage: 26,
			},
			{
				name: 'gold',
				credits_per_month: 200,
				credits_per_week: 60,
				purchased_leads_per_month: 100,
				purchased_leads_per_week: 40,
				price_per_month_in_pence: 2000,
				price_per_week_in_pence: 1524,
				price_per_credit_in_pence: 160,
				discount_percentage: 30,
			},
		],
	},
};

export const customPackageDataMock = () => {
	const packData = {
		name: 'custom',
		credits_per_month: Math.floor(100 + Math.random() * 900),
		credits_per_week: Math.floor(100 + Math.random() * 900),
		purchased_leads_per_month: Math.floor(10 + Math.random() * 90),
		purchased_leads_per_week: Math.floor(10 + Math.random() * 90),
		price_per_month_in_pence: Math.floor(10000 + Math.random() * 90000),
		price_per_week_in_pence: Math.floor(10000 + Math.random() * 90000),
		price_per_credit_in_pence: Math.floor(100 + Math.random() * 900),
		discount_percentage: Math.floor(10 + Math.random() * 90),
	};

	return {
		data: {
			usage: {},
			packages: [packData],
		},
	};
};

export const activeSubscriptionsMock = {
	data: {
		subscriptions: [
			{
				id: '123',
				number_of_credits: 100,
				total_in_pence: 10000,
				subtotal_in_pence: 10000,
				tax_amount_in_pence: 0,
				billing_interval: 'month',
				created_at: '2020-01-01 00:00:00',
			},
			{
				id: '456',
				number_of_credits: 100,
				total_in_pence: 10000,
				subtotal_in_pence: 10000,
				tax_amount_in_pence: 0,
				billing_interval: 'month',
				created_at: '2021-01-01 00:00:00',
			},
		],
	},
};

export const paymentLinkForSellerMock = {
	data: {
		stripe_subscription_id: 'sub_1234',
	},
};

export const prebuiltPackageDataMock = {
	data: {
		number_of_credits: 100,
		subtotal_in_pence: 10000,
		tax_amount_in_pence: 2000,
		billing_interval: 'week',
		currency_code: 'GBP',
		currency_symbol: '£',
		admin_id: 123,
		uuid: '0035fcae-aa06-4978-b721-68e5f14f119e',
	},
};
